<template>
   <div class="crud-wrapper">
      <crud-toolbar :isBlocked="formData.blocked" :modal-mode="modalMode" :new-state="newState" :showDelete="false"
                    :title="modalTitle" @onCommand="toolbarCommand" :showBack="false"></crud-toolbar>

      <crud-form :modal-mode="modalMode" :ref="formName" v-model="validForm">

         <v-layout row wrap>
            <v-flex xs3>
               <v-card flat style="border-radius: 8px">
                  <v-img :aspect-ratio="idRatio" :src="media" style="border-radius: 8px; margin-top: -8px;"></v-img>

                  <v-toolbar flat>
                     <v-spacer></v-spacer>

                     <v-tooltip bottom>
                        <v-btn @click.stop="loadImgClick" color="primary" dark fab
                               slot="activator" small>
                           <v-icon small>fas fa-camera</v-icon>
                        </v-btn>
                        Carregar Imagem (min. 250px por 250px)
                     </v-tooltip>

                     <v-spacer></v-spacer>
                  </v-toolbar>

               </v-card>
            </v-flex>

            <v-flex xs9>
               <v-layout row wrap>
                  <a-text-field :disabled="!newState" autofocus label="Nome da Empresa"
                                text-transform="capitalize" v-model="formData.storeName"
                                validate="required"></a-text-field>

                  <a-text-field :disabled="!newState" label="CNPJ/CPF" sm6
                                v-mask="['##.###.###/####-##', '###.###.###-##']" v-model="formData.federalId"
                                validate="required"></a-text-field>
                  <a-select-field label="Fuso Horário" obj="timeZoneNames" sm6
                                  v-model="formData.time_zoneId"></a-select-field>
                  <a-text-field label="Fone" sm6 v-mask="['(##) ####-####', '(##) #####-####']"
                                v-model="formData.phone"
                                validate="required"></a-text-field>
                  <a-text-field label="WhatsApp" sm6 v-mask="['(##) ####-####', '(##) #####-####']"
                                v-model="formData.whatsapp"
                                validate="required"></a-text-field>
               </v-layout>
            </v-flex>

            <a-text-field label="Email" v-model="formData.email" validate="email"></a-text-field>
            <a-text-field label="Endereço" text-transform="capitalize" v-model="formData.address"></a-text-field>
            <a-text-field label="Cidade" md6 text-transform="capitalize" v-model="formData.city"></a-text-field>
            <a-text-field label="Estado" md3 text-transform="uppercase" v-model="formData.state"></a-text-field>
            <a-text-field label="CEP" mask="##.###-###" md3 v-model="formData.zipcode"></a-text-field>

         </v-layout>

         <template slot="rightContent">
            <v-card flat color="rgba(0,0,0, 0.03)" style="border-radius: 12px; margin-top: -10px">
               <v-card-title class="pb-1 title text-truncate text-no-wrap" primary-title>
                  Usuários Contratados
               </v-card-title>
               <v-card-text class="pt-0">
                  A quantidade de usuários contratados representa o volume de <b>acessos simultâneos</b> que possui para
                  todos que precisam utilizar o sistema (gestores, operadores, etc.).
               </v-card-text>
               <v-container pa-0>
                  <v-layout row wrap>
                     <v-flex style="text-align: center" xs4>
                        <label class="biggerNumber text-center">{{formData.maxPaQty}}</label>
                     </v-flex>
                     <v-flex align-self-center xs8>
                        <v-btn @click="buyMore" color="primary" dark>Comprar Mais</v-btn>
                     </v-flex>
                     <v-flex xs12>
                        <v-divider></v-divider>
                     </v-flex>
                     <v-flex style="text-align: center" xs4>
                        <label class="bigNumber text-center">{{formData.qtyUsers}}</label>
                     </v-flex>
                     <v-flex align-self-center xs8>
                        <v-label class="text-primary">Usuários Cadastrados</v-label>
                     </v-flex>
                     <v-flex xs12 v-if="!formData.partner">
                        <v-divider inset></v-divider>
                     </v-flex>
                     <v-flex style="text-align: center" xs4 v-if="!formData.partner">
                        <label class="bigNumber text-center">{{formData.qtyPartners}}</label>
                     </v-flex>
                     <v-flex align-self-center xs8 v-if="!formData.partner">
                        <v-label class="text-primary">Parceiros Cadastrados</v-label>
                     </v-flex>
                  </v-layout>
               </v-container>
            </v-card>
         </template>

      </crud-form>

   </div>


</template>

<script>
    import CrudFormClass from '@consigmais-team/vue-common/layout/crudPage/crudFormClass';

    export default CrudFormClass.extend({
        name: 'CompanyForm',

        data: function () {
            return {
                title: 'Minha Empresa',
                formName: 'companyForm',

                formData: {
                    id: null,
                    storeName: null,
                    brandLogo: null,
                    address: null,
                    city: null,
                    state: null,
                    zipcode: null,
                    federalId: null,
                    phone: null,
                    whatsapp: null,
                    email: null,
                    time_zoneId: 'America/Sao_Paulo',
                    notes: null,
                    partner: 0,
                    maxPaQty: 0,
                    qtyUsers: 0,
                    qtyPartners: 0
                }

            };
        },

        computed: {
            idRatio () {
                let mediaRatio = 1;
                return mediaRatio;
            },

            media () {
                let media = '/static/images/empty-logo.jpg';

                if (this.formData.brandLogo) {
                    media = this.$config.imageUri(this.formData.brandLogo, 'logo');
                }

                return media;
            }

        },

        methods: {
            loadImgClick () {
                window.cloudinary.openUploadWidget(window.cloudinaryOptions.logos, this.uploadedMedia);
            },

            uploadedMedia (error, result) {
                if (result && result.length) {
                    let res = result[0];
                    this.formData.brandLogo = res.path;
                }
            },

            buyMore () {
                this.$notifyUser({
                    type: 'info',
                    message: `Favor ligar para (84) 99999-9999 para efetivar a contratação.`
                });
            }

        },

        created () {
            this.editKey = this.$store.state.company.user.workingCo;
        }

    });
</script>

<style scoped>
   .bigNumber {
      font-size: 40px;
      font-weight: 400;
   }

   .biggerNumber {
      font-size: 60px;
      font-weight: 500;
   }

</style>



// WEBPACK FOOTER //
// src/pages/Company.vue